import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Button from "_shared/components/Button/Button";
import Loading from "../../_shared/components/Loading/Loading";
import { useAuth } from "../../_shared/contexts/AuthContext";
import "./ThankYou.scss";
import { usePostHog } from "posthog-js/react";

// TODO: this view could go directly into the sign up flow
// the user could be automatically signed in behind the scenes after signing up
export default function ThankYou() {
  const history = useHistory();
  const location = useLocation<{ email: string; password: string }>();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { signIn } = useAuth();
  const posthog = usePostHog();

  // get user details from history state
  useEffect(() => {
    const locationEmail = location.state?.email;
    const locationPassword = location.state?.password;
    if (!locationEmail || !locationPassword) return history.push("/login");
    setEmail(location.state.email ?? "");
    setPassword(location.state.password ?? "");
  }, [history, location]);

  useEffect(() => {
    if (process.env.NODE_ENV === "test") return;
    // Twitter tracking
    (window as any).twq("event", "tw-o90ig-oe3tj", {
      value: null, // use this to pass the value of the conversion (e.g. 5.00)
      currency: null, // use this to pass the currency of the conversion with an ISO 4217 code (e.g. ‘USD’)
      conversion_id: null, // use this to pass a unique ID for the conversion event for deduplication (e.g. order id '1a2b3c')
      email_address: null, // use this to pass a user’s email address
      phone_number: null, // phone number in E164 standard
    });
  }, []);

  return (
    <div id="thank-you-page" style={{ overflow: "hidden !important" }}>
      <div>
        <img
          className="logo"
          src="/logo_dark.svg"
          style={{ height: 85, position: "relative", right: "20px" }}
          alt="Longbow Logo"
        />
        <div className="card">
          <div className="border-padding">
            <i className="justify-center check-icon far fa-check-circle"></i>
            <h2 className="justify-center thank-you-text">Thank you!</h2>

            <div style={{ textAlign: "center" }}>
              You will receive an email confirmation
            </div>
            <div style={{ textAlign: "center" }}>
              shortly at{" "}
              <div style={{ display: "inline" }} className="email">
                {email}
              </div>
            </div>

            <div style={{ margin: "4rem 0" }}>
              <Button
                data-testid="button-dashboard"
                type="submit"
                onClick={async () => {
                  setLoading(true);
                  try {
                    // do not remember user by default
                    await signIn(email, password, false);
                    history.push("/dashboard/macro-etfs");
                  } catch (err) {
                    alert(JSON.stringify(err));
                    setLoading(false);
                  }
                }}
                fullWidth
              >
                Continue to Dashboard
              </Button>
            </div>
          </div>
        </div>
      </div>
      {loading && <Loading message={""} />}
    </div>
  );
}
